export const ONE_YEAR_MILLISECONDS = 365 * 24 * 60 * 60 * 1000;

export const SESSION_EXPIRATION_TIME_V2 = 1800000;
export const IDLE_COUNTER_TIME_V2 = 300000;
// These are for testing only
// export const SESSION_EXPIRATION_TIME_V2 = 180000;
// export const IDLE_COUNTER_TIME_V2 = 60000;

export const footerLinks = {
    "privacy-policy": "Privacy Policy",
    "terms-of-use": "Terms of Use",
    accessibility: "Accessibility",
};

export const PRIVACY_POLICY = "privacy-policy";
export const TERMS_OF_USE = "terms-of-use";
export const ACCESSIBILITY = "accessibility";

export const DEFAULT_SIDEBAR_MENU_NAMES = {
    DASHBOARD: "dashboard",
    INVENTORY: "inventory",
    DOCUMENTS: "documents",
    DIVIDER: "divider",
    TOOLS: "tools",
    HELP: "help",
    SEARCH: "search",
};

export const SIDEBAR_MENU_ITEMS_ORDER = [
    DEFAULT_SIDEBAR_MENU_NAMES.DASHBOARD,
    DEFAULT_SIDEBAR_MENU_NAMES.INVENTORY,
    DEFAULT_SIDEBAR_MENU_NAMES.DOCUMENTS,
    DEFAULT_SIDEBAR_MENU_NAMES.SEARCH,
    DEFAULT_SIDEBAR_MENU_NAMES.TOOLS,
    DEFAULT_SIDEBAR_MENU_NAMES.HELP,
];

export const DEFAULT_HEADER_MENU_ITEMS = {
    USER_DROPDOWN: { name: "userDropdown", order: 3 },
};

export const DEFAULT_DROPDOWN_MENU_ITEMS = {
    LOGOUT: { name: "logout", order: 9999 },
};

export const MENU_ACCESS = {
    ADMIN: ["Administer Business Rules.Read"],
    MANAGER_DASHBOARD: ["Teams Inventory.Read"],
    SEARCH: "Standard Access.Read",
    INVENTORY: ["My Assigned Cases.Read", "Teams Inventory.Read"],
    DOCUMENTS: "ReviewUnmatchedMedicalRecord",
    TOOLS: "User Profile Configuration.Read",
    HELP: ["Standard Access.Read"],
    HAS_DIVIDER: ["My Assigned Cases.Read", "Teams Inventory.Read"],
    SYS_ADMIN: ["System Admin.Read"],
};

export const USER_ROLE_NAMES = {
    EPV_INVESTIGATOR: "EPV Investigator",
};

export const WorkStatus = {
    PROD: "production",
    EXCEPTION_TIME: "EXCTIME",
    LOST_TIME: "LSTTIME",
    LUNCH: "lunch",
    BREAK: "break",
};

export const ExceptionSubWorkStatus = {
    TAFW: "TAFW",
    SYS_LOGOUT: "SYS_LOGOUT",
};

export const LogMessages = {
    INITIATED_EVENT: "User clicked button event",
    COMPLETED_EVENT: "User completed button event",
    ERRORED_EVENT: "An error occurred during the button event",
};

// UMDS Permission types
// https://confluence.optum.com/pages/viewpage.action?pageId=144067297
export enum PermissionsTypes {
    TrackProductivity = "Track Productivity.Read",
    TrackProductivityForSME = "Track Productivity for SME.Read",
}

export const SHOW_PREFERENTIAL_ROUTING_TOGGLE = "showPreferentialRoutingToggle";

export const UMDS_ERROR_TYPE = {
    BAD_REQUEST: "BAD REQUEST",
    INTERNAL_ERROR: "INTERNAL_ERROR",
};

export const TIMETRACK_CASE_EVENT = "CASE_EVENT";
export const TIMETRACK_DOCUMENT_EVENT = "UNMATCHED_DOC_EVENT";
export const TIMETRACK_EXTERNAL_TRACKING_ID = "externalTrackingId";
export const TIMETRACK_DOC_EXTERNAL_TRACKING_ID = "docExternalTrackingId";

export const UI_BACKEND_ROOT_URL = "/ui/inv-shell/api";

export const VALUESTREAM_PLUS_VALUES = {
    CLINICAL_UNITED: "ClinicalUnited",
    CLINICAL_COMMERCIAL: "ClinicalCommercial",
    NON_CLINICAL: "NonClinical",
};

export const OPI_INVESTIGATIONS_ORG = "PRVINV";
